import * as React from 'react';

import ProjectRecommendationsModuleNotConfigurable from 'bundles/unified-description-page-common/components/recommendations/ProjectRecommendationsModuleNotConfigurable';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import type { CollectionEntityFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/CollectionEntityFragment';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';

type Props = {
  pageData?: ConsumerCoursePageFieldsFragment;
};

const ConsumerProjectRecommendationsModuleRenderer = ({ pageData }: Props) => {
  const { navigationIdMap } = usePageInfo();

  return (
    <ProjectRecommendationsModuleNotConfigurable
      anchorId={navigationIdMap?.RECOMMENDATIONS}
      recommendationsCollection={pageData?.relatedRecommendations as CollectionEntityFragment[]}
    />
  );
};

export default ConsumerProjectRecommendationsModuleRenderer;
